var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{style:(`background-color: ${_vm.roleBg}; border-color: ${_vm.roleBg}`),attrs:{"small":""}},[_c('span',{staticClass:"p-3",style:(`color: ${_vm.roleText}`)},[_vm._v(" "+_vm._s(_vm.role)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }